module.exports = __webpack_public_path__ + "static/media/done.ecdc9452.gif";